import React, { useContext, useEffect, useState } from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import EmailRoundedIcon from "@material-ui/icons/EmailRounded";
import Typography from "@material-ui/core/Typography";
import PlaceRoundedIcon from "@material-ui/icons/PlaceRounded";
import PhoneRoundedIcon from "@material-ui/icons/PhoneRounded";
import ShareIcon from "@material-ui/icons/Share";

import kbcIcon from "../assets/images/kbc_icon.svg";
import kbcPurpleIcon from "../assets/images/kbc_icon_purple.svg";
import { getHospitalInfo, getHospitalInfoById } from "../api/hospital";
import { HospitalInfo } from "../types/hospital";
import { PublicHospitalsContext } from "../pages/PublicStatistics/PublicStatistics";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    img: {
      width: 90,
      height: 90,
      marginRight: theme.spacing(2),
    },
    purpleContainer: {
      background: theme.palette.secondary.main,
      color: "#fff",
      padding: theme.spacing(4),
    },
    whiteContainer: {
      background: "#fff",
      color: theme.palette.secondary.main,
      padding: theme.spacing(4),
      marginTop: theme.spacing(2),
    },
    region: {
      textTransform: "uppercase",
      marginTop: theme.spacing(3),
    },
    icon: {
      margin: theme.spacing(0, 2),
      [theme.breakpoints.only("xs")]: {
        marginLeft: 0,
      },
    },
    center: {
      display: "flex",
      alignItems: "center",
    },
  })
);

type HospitalInfoPanelProps = {
  isPublic?: boolean;
};

export default function HospitalInfoPanel({
  isPublic,
}: HospitalInfoPanelProps) {
  const classes = useStyles();
  const [hospitalInfo, setHospitalInfo] = useState<HospitalInfo>();
  const { currentPublicHospital } = useContext(PublicHospitalsContext);

  useEffect(() => {
    async function fetchData() {
      let response;
      if (isPublic) {
        response = await getHospitalInfoById(currentPublicHospital);
      } else {
        response = await getHospitalInfo();
      }
      setHospitalInfo(response.data);
    }

    fetchData();
  }, [currentPublicHospital]);

  const sideInfo = [
    {
      text:
        hospitalInfo &&
        hospitalInfo.streetAddress +
          ", " +
          hospitalInfo.cityPostcode +
          " " +
          hospitalInfo.cityName,
      icon: <PlaceRoundedIcon className={classes.icon} />,
    },
    {
      text: hospitalInfo && hospitalInfo.phone1,
      icon: <PhoneRoundedIcon className={classes.icon} />,
    },
    {
      text: hospitalInfo && hospitalInfo.phone2,
      icon: hospitalInfo && hospitalInfo.phone2 && (
        <PhoneRoundedIcon className={classes.icon} />
      ),
    },
    {
      text: hospitalInfo && hospitalInfo.website && (
        <a
          href={hospitalInfo && hospitalInfo.website}
          style={isPublic ? { color: "#992468" } : { color: "#fff" }}
          target="_blank"
        >
          Link na web stranice ustanove
        </a>
      ),
      icon: hospitalInfo && hospitalInfo.website && (
        <ShareIcon className={classes.icon} />
      ),
    },
    {
      text: hospitalInfo && hospitalInfo.email,
      icon: hospitalInfo && hospitalInfo.email && (
        <EmailRoundedIcon className={classes.icon} />
      ),
    },
  ];

  return (
    <div className={classes.root}>
      <Grid
        container
        className={isPublic ? classes.whiteContainer : classes.purpleContainer}
      >
        <Grid item>
          <img
            className={classes.img}
            alt="kbc-icon"
            src={isPublic ? kbcPurpleIcon : kbcIcon}
          />
        </Grid>
        <Grid item sm container>
          <Grid item xs container direction="column">
            <Grid item>
              <Typography variant="body2">
                {hospitalInfo && hospitalInfo.name}
              </Typography>
              <Typography variant="subtitle1" className={classes.region}>
                {hospitalInfo && hospitalInfo.cityRegionName}
              </Typography>
            </Grid>
          </Grid>

          <Grid item>
            {sideInfo.map((item, index) => {
              return (
                <Typography
                  variant="subtitle1"
                  className={classes.center}
                  key={index}
                >
                  {item.icon}
                  {item.text}
                </Typography>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
